/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IGetQuestionsWebRequest {
  /** id ЖК **/
  newbuildingId: number;
  /** Пагинация **/
  page?: TGetQuestionsWebRequest_Page;
  /** Загрузить все вопросы? **/
  getAllItems?: TGetQuestionsWebRequest_GetAllItems;
  /** Сортировка **/
  sort?: TGetQuestionsWebRequest_Sort;
}

export type TGetQuestionsWebRequest_Page = null | number;

export type TGetQuestionsWebRequest_GetAllItems = null | boolean;

export type TGetQuestionsWebRequest_Sort = null | ESort;

export enum ESort {
  /** По умолчанию **/
  'Default' = 'default',
  /** По дате (сначала новые) **/
  'By_date_asc' = 'by_date_asc',
  /** По дате (сначала старые) **/
  'By_date_desc' = 'by_date_desc',
}
